import { render, staticRenderFns } from "./TableBase.vue?vue&type=template&id=0a6079a2&scoped=true&lang=pug"
import script from "./TableBase.vue?vue&type=script&lang=ts"
export * from "./TableBase.vue?vue&type=script&lang=ts"
import style0 from "./TableBase.vue?vue&type=style&index=0&id=0a6079a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6079a2",
  null
  
)

export default component.exports